import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../lib-shared/services/base.service';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DistrictsService extends BaseService {
    constructor(http, injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Districts`);
    }
    Gets(key, idProvince, idDistrict, offset, limit, sortField, isAsc = false) {
        const queryString = `${this.serviceUri}?key=${key}&idProvince=${idProvince}&idDistrict=${idDistrict}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }
    Save(item) {
        return this._http
            .post(this.serviceUri, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
    GetShort(idProvince) {
        const queryString = `${this.serviceUri}/GetShort?idProvince=${idProvince}`;
        return this.defaultGet(queryString);
    }
    ChangeDeleted(item) {
        return this._http
            .post(this.serviceUri + '/ChangeDeleted/' + item.id, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
}
DistrictsService.ngInjectableDef = i0.defineInjectable({ factory: function DistrictsService_Factory() { return new DistrictsService(i0.inject(i1.HttpClient), i0.inject(i0.INJECTOR)); }, token: DistrictsService, providedIn: "root" });
